import * as yup from "yup";

const regexPlacas = /^[A-Za-z]{3}-?\d[0-9A-Za-z]\d{2}$/;

export const filtrosListarLicenciamentos = yup.object({
  placa: yup.string().optional().nullable().matches(regexPlacas, {
    excludeEmptyString: true,
    message: "Placa inválida",
  }),

  statusEmissao: yup
    .string()
    .oneOf([
      "EMITIDO",
      "PROCESSANDO",
      "FALHA",
      "DADOS_INCONSISTENTES",
      "EXERCICIO_INDISPONIVEL",
    ])
    .optional()
    .nullable(),

  renavam: yup.string().optional().nullable().max(11),

  exercicio: yup.number().optional().nullable(),
});

export const emissaoManual = yup.object().shape({
  dataEmissao: yup.date().required("Data de emissão é obrigatória"),
  exercicio: yup.number().required("Informe o ano"),
  arquivo: yup
    .mixed()
    .test("file-selected", "Selecione um arquivo", (value) => {
      return value instanceof File && value.size > 0;
    })
    .required("Selecione um arquivo")
    .nonNullable(),
});
